// Firebase initialization for Cognidoor
import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, OAuthProvider } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyB_9IxSE3W64Cx3j95UUp5Ap9fV76HoWKs",
  authDomain: "cognidoor-e05a2.firebaseapp.com",
  projectId: "cognidoor-e05a2",
  storageBucket: "cognidoor-e05a2.appspot.com",
  messagingSenderId: "92219505867",
  appId: "1:92219505867:web:d0eaa13fb1a4ac47316f4e",
  measurementId: "G-CJRWZCMLRW"
};

// Ensure Firebase is only initialized once (singleton pattern)
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
const analytics = getAnalytics(app);
const auth = getAuth(app);

// Initialize Firestore with cogniauth database using the correct method
const db = getFirestore(app, 'cogniauth');

// Providers
const googleProvider = new GoogleAuthProvider();
const appleProvider = new OAuthProvider('apple.com');

export { app, analytics, auth, db, googleProvider, appleProvider }; 